/*
 * Links maskieren
 * wandelt span-Tags, die ein data-link Attribute (Base64 codierte URL) enthalten, beim Hovern oder Touchen in ein regulÃ¤res a-Tag um
 * Vorteile: Diese Umsetzung erlaubt auch einen Rechtsklick und lÃ¤sst dem Benutzer die Option, ob er den Link kopieren, in einem neuen Fenster Ã¶ffnen mÃ¶chte, etc.
 * Innerhalb des <span-Tags kÃ¶nnen beliebige Attribute vorkommen, die alle in den A-Tag Ã¼bernommen werden, wie z.B.:
 * 
 * <span data-link="BASE64_URL" title="SchÃ¶ner Link">
 * <span data-link="BASE64_URL" rel="nofollow">
 * <span data-link="BASE64_URL" target="_blank">
 */


/* alle Elemente, die data-link Attribut enthalten */
var elements = document.querySelectorAll("[data-link]");
            
elements.forEach(element => {
    element.addEventListener("mouseover", event => {
        span2link(element, false);
    });

    element.addEventListener('click', event => {
        span2link(element, true); 
    });           
});

function span2link(element, click) {   
    /* Erstelle a-Tag fÃ¼r das span-Tag */
    var replacement = document.createElement('a');

    /* Hole alle originalen Attribute und fÃ¼ge sie dem Ersatz-Tag hinzu */
    for(var i = 0, l = element.attributes.length; i < l; ++i){
        var nodeName  = element.attributes.item(i).nodeName;
        var nodeValue = element.attributes.item(i).nodeValue;

        /* auÃŸer es handelt sich um das Attribut data-link */
        if(nodeName == 'data-link') {
            /* dieses Attribut durch href ersetzen */
            nodeName = 'href';
            
            /* und den Wert Base64 dekodieren und zuweisen */
            nodeValue = atob(nodeValue);
        }
        
        /* ERsetzung durchfÃ¼hren*/
        replacement.setAttribute(nodeName, nodeValue);
    }

    /* Ersatz-Tag zusammensetzen */
    replacement.innerHTML = element.innerHTML;

    /* und ab ins DOM dasmit */
    element.parentNode.replaceChild(replacement, element);
    console.log("Changed: " + element);
    
    element.stopPropagation();
    
    /* Parameter click = true bei Touch-GerÃ¤ten */
    if(click) {
        /* dann zusÃ¤tzlich einen Klick auf das Ersatz-Tag (a href) ausfÃ¼hren */
        replacement.click();
    }
}